module.exports = __webpack_public_path__ + "static/media/frilans-finans.f6bbacb6.svg";